import {useEffect,useRef,useState} from 'react';
import {authenticatedFetch} from '../api';

/** Only fetch authorised previews near the viewport. A 100-image page must not
 * download 100 originals at once. Every URL retains its existing access checks. */
export function MediaThumbnail({url,alt,available=true}:{url:string;alt:string;available?:boolean}){
 const host=useRef<HTMLDivElement>(null),[visible,setVisible]=useState(false);
 const [image,setImage]=useState<{key:string;url?:string;failed?:boolean}>();
 useEffect(()=>{const target=host.current;if(!target)return;const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){setVisible(true);observer.disconnect();}},{rootMargin:'200px'});observer.observe(target);return()=>observer.disconnect();},[url]);
 useEffect(()=>{if(!visible||!available)return;const controller=new AbortController();let objectUrl:string|undefined;
  void authenticatedFetch(url,{signal:controller.signal}).then(async response=>{if(!response.ok)throw Error('Unavailable');
 const blob=await response.blob();
 if(!blob.type.startsWith('image/'))throw Error('No image preview');
 if(controller.signal.aborted)return;
 objectUrl=URL.createObjectURL(blob);
 setImage({key:url,url:objectUrl});
 }).catch(()=>{if(!controller.signal.aborted)setImage({key:url,failed:true});
 });

  return()=>{controller.abort();if(objectUrl)URL.revokeObjectURL(objectUrl);};
 },[url,visible,available]);
 const current=image?.key===url?image:undefined;
 return <div ref={host} className="media-thumbnail">{current?.url?<img src={current.url} alt={alt}/>:<div className="media-placeholder">{!available?'Preview unavailable':current?.failed?'Preview could not be loaded':'Loading preview…'}</div>}</div>;
}
